export default class BoletoEntity {
  status = null;
	dataVencimento = null;
	valorTotal = null;
  nfSaidaId = null;
	clienteId = null;
	meioPagamentoId = null;
  convenioId = null;
  integradorId = null;
  integradorImpressaoId = null;
  tituloDocumento = null;
  tituloNossoNumero = null;
	observacoes = null;

	constructor(boletoApi, boletoInformacoes, clienteId, observacoes) {
		if (!boletoApi) {
			this.status = "FALHA";
		} else if (!boletoInformacoes?.registroInstantaneo) {
			this.status = "EMITIDO";
		} else {
			this.status = boletoApi.situacao;
		}
		this.dataVencimento = boletoInformacoes?.dataVencimento;
		this.valorTotal = boletoInformacoes?.valorTitulo;
		this.nfSaidaId = boletoInformacoes?.nfSaidaId;
		this.clienteId = clienteId;
		this.meioPagamentoId = boletoInformacoes?.meioPagamentoId;
		this.convenioId = boletoInformacoes?.convenioId;
		this.integradorId = boletoApi?.idintegracao;
		this.integradorImpressaoId = boletoApi?.idImpressao;
		this.tituloDocumento = boletoInformacoes?.tituloDocumento;
		this.tituloNossoNumero = boletoApi?.TituloNossoNumero;
		this.observacoes = observacoes;
	}
}